import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import featuresData from '~/js/views/resorts/components/palm-suites/data/features';

const internals = {
    sliderOptions: {
        lazyLoad: 'ondemand',
        arrows: false,
        dots: true,
        customPaging: () => <span className="dot" />
    }
};

const featuresIcon = args => {
    const { roomIndex, featureIndex, type, state, closeHandler } = args;
    const { className, featureName, description } = featuresData[type] || {};
    const isOpen =
        state &&
        state.roomIndex === roomIndex &&
        state.featureIndex === featureIndex;

    let popover;

    if (isOpen) {
        popover = (
            <div
                className="features-popover"
                style={{ bottom: state.bottomPos }}
            >
                <i className="popover-close" onClick={closeHandler} />

                <div className="popover-inner">
                    <i className={`ic ${className}`} />
                    <div>
                        <h2>{featureName}</h2>
                        <p>{description}</p>
                    </div>
                </div>

                <i className="arrow" style={{ left: state.arrowLeft }} />
            </div>
        );
    }

    return (
        <Fragment>
            <i className={`ic ${className} ${isOpen ? 'open' : ''}`} />
            {popover}
        </Fragment>
    );
};

const RoomsSuitesItem = props => {
    const {
        roomIndex,
        type,
        className,
        rstCode,
        images,
        name,
        description,
        roomView,
        features,
        // rate,
        promotions,
        detailsLink,
        popoverState,
        openPopoverHandler,
        closePopoverHandler
    } = props;

    const { sliderOptions } = internals;
    // const isBestValue = features.includes('Best Value Consumer');
    const isMobile = window.innerWidth < 768;
    const isGrid = type === 'grid';

    let roomViewList;
    let featuresList;

    if (roomView) {
        roomViewList = (
            <div className="room-view">
                <span>ROOM VIEW:</span> {roomView}
            </div>
        );
    }

    if (features) {
        featuresList = (
            <ul className="features-list">
                {features.map((el, index) => {
                    const args = {
                        roomIndex: roomIndex,
                        featureIndex: index,
                        type: el,
                        state: popoverState,
                        closeHandler: closePopoverHandler
                    };

                    const clickHandler = e => {
                        openPopoverHandler(e, roomIndex, index);
                    };

                    if (!featuresData[el]) {
                        return null;
                    }

                    return (
                        <li key={index} onClick={clickHandler}>
                            {featuresIcon(args)}
                        </li>
                    );
                })}
            </ul>
        );
    }

    return (
        <div className={`item ${type} ${className}`}>
            <div className="item-panel">
                <div className="slider">
                    <Slider {...sliderOptions}>
                        {images.map((image, index) => {
                            const source = `http://cdn.sandals.com/sandals/v11/media/${rstCode}/accommodations/medium/${rstCode}-${image}-medium.jpg`;

                            return (
                                <div key={index}>
                                    <div className="equal-image">
                                        <img
                                            src={source}
                                            data-lazy={source}
                                            alt={`Slide ${image}`}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>

                    {isGrid && <div className="slider-caption">{name}</div>}
                </div>
                {/* <div className="price">
                    {isBestValue && <span className="label"><b>Best</b> Value</span>}
                    <span className="from">from</span>
                    <span className="num">${rate}</span>
                    <span><small>PP/PN</small>(USD)</span>
                </div> */}

                {roomViewList}
                {featuresList}

                <a href={detailsLink} className="details-link">
                    Room Details
                </a>
            </div>

            {!isGrid && (
                <div className="item-description">
                    <h2 className="item-title">{name}</h2>
                    <p>{description}</p>
                </div>
            )}

            {/* !isGrid && <div className="item-qualification">
                <h2 className="item-title-2">THIS ROOM QUALIFIES FOR:</h2>
                {promotions.length ? <ul className="qualification-list">
                    {promotions.map((el, index) => {
                        const closeBtn = '<button title="%title%" type="button" class="mfp-close"></button>';
                        const modalInner = (
                            `<div class="modal-window">
                                <h3 class="mdp-title">${el.promotionTitle}</h3>

                                ${el.promotionDescription}

                                <div class="popup-content-btn text-center">
                                    <a href="/book-now/?reference=obe&resortCode=${rstCode}&isMobile=${isMobile}" target="_blank">
                                        <span class="dsc-quote-btn">Get Quote</span>
                                    </a>
                                </div>
                            </div>`
                        );

                        const clickHandler = () => {
                            $.magnificPopup.open({
                                items: {
                                    src: modalInner,
                                    type: 'inline'
                                },
                                closeMarkup: closeBtn
                            });
                        };

                        return (
                            <li
                                key={index}
                                onClick={clickHandler}>
                                {el.promotionTitle}
                            </li>
                        );
                    })}
                </ul> : <div className="no-data">There are no promotions</div>}
            </div> */}
        </div>
    );
};

RoomsSuitesItem.propTypes = {
    roomIndex: PropTypes.number,
    type: PropTypes.string,
    rstCode: PropTypes.string,
    className: PropTypes.string,
    images: PropTypes.array,
    name: PropTypes.string,
    description: PropTypes.string,
    roomView: PropTypes.string,
    features: PropTypes.array,
    rate: PropTypes.number,
    promotions: PropTypes.array,
    detailsLink: PropTypes.string,
    popoverState: PropTypes.object,
    openPopoverHandler: PropTypes.func,
    closePopoverHandler: PropTypes.func
};

RoomsSuitesItem.defaultProps = {
    type: 'grid',
    rstCode: '',
    className: '',
    images: [],
    rate: 0,
    promotions: [],
    detailsLink: '#'
};

export default RoomsSuitesItem;
